module.exports = __webpack_public_path__ + "static/media/tempBox.462c9548.png";